import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

/** Returns the set of menu keys the current user is allowed to see. */
export function useMyMenus(role) {
  const [menus, setMenus] = useState(null);
  const reload = useCallback(() => {
    if (!role) { setMenus(null); return; }
    api.get("/me/menus")
      .then((r) => setMenus(new Set(r.data.visible_menus || [])))
      .catch(() => setMenus(new Set()));
  }, [role]);
  useEffect(() => { reload(); }, [reload]);
  return { menus, reload };
}
